import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonPage, IonRouterOutlet, IonContent } from "@ionic/vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Onboarding',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRouterOutlet))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})